import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, CardBody, Card, Table, } from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

//redux
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { DatePickerInput, DatesProvider } from '@mantine/dates';
import { setRequireCloseModal } from '../../../slices/personalProtectiveEquipment/reducer';
import { getEstablishmentList, getPersonList, } from '../../../helpers/establishment/backend_helper';
import { updatePersonalProtectiveEquipment, addNewPersonalProtectiveEquipment, getWarehouseItemList, reserveWarehouseItem, uploadFoldersFile, getPersonalProtectiveEquipmentByPersonId, getUserByRoles, sendNewEmailMessage, addNewBulkNotification, releaseWarehouseItem, deleteFile, establishmentUser, getPersonalProtectiveEquipmentStatusDefaultRegularization, transferWarehouseItemTransfer, getWarehouseItemTransferList, } from '../../../slices/thunks';
import OSelect from '../../../Components/OElements/OSelect';
import {
    getPersonalProtectiveEquipmentReasonList,
    getPersonalProtectiveEquipmentStatusList as getPersonalProtectiveEquipmentStatusListApi,
    getWarehouseList,
    transferWarehouseItem
} from '../../../helpers/warehouse/backend_helper';
import SimpleBar from 'simplebar-react';
import useLogoLoader from '../../../Components/Hooks/useLogoLoaderHooks';
import { generatePDF } from '../Document/PPEDocument';
import useFileType from '../../../Components/Hooks/useFileTypeHooks';
import useFolderPaths from '../../../Components/Hooks/useFolderPathsHooks';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import OInput from '../../../Components/OElements/OInput';
import { setWarehouseItemList } from '../../../slices/warehouseItem/reducer';

const PersonalProtectiveEquipmentTransferForm = ({
    dataPersonalProtectiveEquipment,
    isEdit,
    handleToggleModal,
    isOpen,
    activeTab,
    toggleTab,
    establishmentId
}) => {
    const dispatch = useDispatch();
    const { logoSrc } = useLogoLoader('login');
    const [folderPaths, setFolderPaths] = useState([]);
    const [dataListPerson, setDataListPerson] = useState([]);
    const [selectedEstablishment, setSelectedEstablishment] = useState(null);
    const [selectedReason, setSelectedReason] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [selectedWarehouse, setSelectedWarehouse] = useState(null);
    const [selectedDestinationWarehouse, setSelectedDestinationWarehouse] = useState(null);
    const [selectedPerson, setSelectedPerson] = useState(null);
    const [loading, setLoading] = useState(false);
    const [costCenterList, setCostCenterList] = useState([]);
    const [costCenterDefault, setCostCenterDefault] = useState(null);


    const selectorPersonalProtectiveEquipment = createSelector(
        state => state.PersonalProtectiveEquipments,
        data => ({
            isAdding: data.isAdding,
            isAdded: data.isAdded,
            isUpdating: data.isUpdating,
            isUpdated: data.isUpdated,
            isLoadingList: data.isLoadingList,
            requireCloseModal: data.requireCloseModal,
            personalProtectiveEquipmentList: data.personalProtectiveEquipmentList,
            personalProtectiveEquipmentStatusDefaultRegularization: data.personalProtectiveEquipmentStatusDefaultRegularization,
            isPersonalProtectiveEquipmentStatusDefaultRegularizationLoading: data.isPersonalProtectiveEquipmentStatusDefaultRegularizationLoading,
            isPersonalProtectiveEquipmentStatusDefaultRegularizationSuccess: data.isPersonalProtectiveEquipmentStatusDefaultRegularizationSuccess
        })
    );
    const {
        isAdding,
        isUpdating,
        isUpdated,
        isLoadingList,
        requireCloseModal,
        personalProtectiveEquipmentList,
        personalProtectiveEquipmentStatusDefaultRegularization,
        isPersonalProtectiveEquipmentStatusDefaultRegularizationLoading,
        isPersonalProtectiveEquipmentStatusDefaultRegularizationSuccess
    } = useSelector(selectorPersonalProtectiveEquipment);


    const selectorItems = createSelector(
        state => state.WarehouseItems,
        data => ({
            dataList: data.warehouseItemList,
        })
    );
    const { dataList = [] } = useSelector(selectorItems);
    const { file_type } = useFileType('EPP');

    const selectorUser = createSelector(
        state => state.Roles,
        result => ({
            users: result.itemUserRoleList,
        })
    );
    const { users } = useSelector(selectorUser);


    const [to, setTo] = useState([]);
    const [cc, setCC] = useState([]);

    useEffect(() => {
        const fetchDataTo = async () => {
            const roles = ['BDG'];
            const params = { roles: roles.join(',') };

            try {
                const response = await dispatch(getUserByRoles(params)).unwrap();
                setTo(response);
            } catch (error) {
                console.error('Error al obtener usuarios TO:', error);
            }
        };

        const fetchDataCc = async () => {
            const roles = ['SSO'];
            const params = { roles: roles.join(',') };

            try {
                const response = await dispatch(getUserByRoles(params)).unwrap();
                setCC(response);
            } catch (error) {
                console.error('Error al obtener usuarios CC:', error);
            }
        };

        fetchDataTo();
        fetchDataCc();
    }, [dispatch]);

    useEffect(() => {
        // Load EPP initial
        dispatch(getPersonalProtectiveEquipmentStatusDefaultRegularization({codes: 'AGD'}))
    }, [])

    const uploadDocument = async (file, folderPaths, fileTypeId, establishmentId) => {
        if (!(file instanceof File)) {
            throw new Error("El archivo seleccionado no es válido.");
        }

        const formData = new FormData();
        formData.append("file", file);
        formData.append("file_type_id", fileTypeId);
        formData.append("establishment_id", establishmentId);

        folderPaths.forEach(path => formData.append("folder_paths", path));

        // console.log("FormData antes de la subida:");
        // for (let pair of formData.entries()) {
        // 	console.log(pair[0], pair[1]);
        // }

        try {
            const response = await dispatch(uploadFoldersFile(formData)).unwrap();
            return response;
        } catch (error) {
            console.error("Error uploading file:", error);
            throw error;
        }
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            establishment_id: '',
            warehouse_destination_id: '',
            warehouse_id: '',
            document: null,
            document_num: null,
            warehouse_items: [],
        },
        validationSchema: Yup.object({
            establishment_id: Yup.string().required('Campo requerido'),
            warehouse_destination_id: Yup.string().required('Campo requerido'),
            warehouse_id: Yup.string().required('Campo requerido'),
        }),
        onSubmit: async values => {
            setLoading(true);

            // Validar que haya al menos un ítem seleccionado
            if (Object.keys(selectedItems).length === 0) {
                toast.error('Debe seleccionar al menos un ítem para asignar.');
                setLoading(false);
                return;
            }

            // Construir el arreglo assigned_items basado en los ítems seleccionados
            const assignedItems = Object.keys(selectedItems).map(itemId => {
                const item = dataList.find(i => i._id === itemId);

                return {
                    warehouse_id: values.warehouse_id,
                    warehouse_code: selectedWarehouse.code_sap,
                    warehouse_group_id: item.warehouse_group_id,
                    warehouse_group_code: item.warehouse_group.code_sap,
                    warehouse_item_id: item._id,
                    warehouse_category_name: item.warehouse_category?.name || '',
                    name: item.name || '',
                    description: item.description || '',
                    quantity: selectedItems[itemId].quantity || 1,
                    size: item.size || '',
                    color: item.color || '',
                    price: item.price || 0,
                    unit_measurement_name: item.unit_measurement?.name || '',
                };
            });

            const formData = {
                warehouse_items: assignedItems,
                establishment_id: validation.values.establishment_id,
                warehouse_destination_id: validation.values.warehouse_destination_id,
                warehouse_origin_id: validation.values.warehouse_id,
                document_id: '',
                document_number: ''
            }

            try {
                if(validation.values.document == null){

                    
                    let documents = null;
                    const folder = '/' + selectedEstablishment.establishment_type.name + '/' + (selectedEstablishment.code_siep ? selectedEstablishment.code_siep + ' - ' : '') + selectedEstablishment.name + '/Abastecimiento/EPP/Transferencias';
                    const updatedFolderPaths = [...folderPaths, folder];
                    setFolderPaths(updatedFolderPaths);

                    try {
                        documents = await uploadDocument(validation.values.document, updatedFolderPaths, file_type._id, values.establishment_id);
                    } catch (error) {
                        setIsDisabled(false);
                        return;
                    }
                    const document = documents[documents.length - 1];

                    if (document?._id) {
                        formData.document_id = document._id;
                    }
                }
                let transfer;
                if (isEdit) {
                    // transfer = await dispatch(transferWarehouseItemTransfer(formData)).unwrap();
                } else {
                    transfer = await dispatch(transferWarehouseItemTransfer(formData)).unwrap();
                }
                dispatch(getWarehouseItemTransferList({
                    establishment_id: establishmentId,
                    warehouse_usage_type_code: 'EPP',
                    all: true
                }));
                setLoading(false);
                dispatch(setRequireCloseModal(true));
                handleToggleModal();
            } catch (err) {
                console.error('Error al guardar:', err);
                toast.error('Hubo un error al guardar la información');
            }
        }
    });

    // Estado para filtros y selección
    const [selectedItems, setSelectedItems] = useState({});
    const [selectedItemsLast, setSelectedItemsLast] = useState({});
    const [hasSavedInitialAssignedItems, setHasSavedInitialAssignedItems] = useState(false);
    const [filteredDataList, setFilteredDataList] = useState(dataList);

    const [sizeFilter, setSizeFilter] = useState(null);
    const [categoryFilter, setCategoryFilter] = useState(null);
    const [phraseFilter, setPhraseFilter] = useState(null);

    const [sizeOptions, setSizeOptions] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);

    useEffect(() => {
        if (isEdit && dataPersonalProtectiveEquipment && dataPersonalProtectiveEquipment._id && dataPersonalProtectiveEquipment.assigned_items && !hasSavedInitialAssignedItems) {
            setSelectedItemsLast(dataPersonalProtectiveEquipment.assigned_items);
            setHasSavedInitialAssignedItems(true);
        }
    }, [isEdit, dataPersonalProtectiveEquipment]);

    useEffect(() => {
        if(!isOpen) {
            setFilteredDataList([]);
            dispatch(setWarehouseItemList([]));
        };
    }, [isOpen])

    function restoreAvailableStockItems(warehouseItems, assignedItems){
        // Restore item availability by adding back previously assigned quantities
        // This resets stock levels before applying a new reservation or validation
        if(assignedItems){
            const adjustedItemsAvailableStock = warehouseItems.map((warehouseItem) => {
                const item_assigned_found = assignedItems.find(
                    assigned_item => 
                        assigned_item.warehouse_item_id == warehouseItem._id
                );
                return (
                    item_assigned_found
                        ? {
                            ...warehouseItem, 
                            available: (warehouseItem.available + item_assigned_found.quantity)
                        } 
                        : warehouseItem
                    );
            })
            return adjustedItemsAvailableStock
        }else{
            return warehouseItems;	
        }
    }

    useEffect(() => {
        if (!dataList || dataList.length === 0) {
            setFilteredDataList([]);
            setSizeOptions([]);
            setCategoryOptions([]);
            setPhraseFilter(null);
            return;
        }

        // Recalculate available stock by restoring previously assigned quantities
        const adjustedItemsAvailableStock = restoreAvailableStockItems(
            dataList, 
            dataPersonalProtectiveEquipment.assigned_items
        );
        
        setFilteredDataList(adjustedItemsAvailableStock);

        // Crear opciones para los selects
        const newSizeOptions = [...new Set(dataList.map(item => item.size).filter(Boolean))].map(size => ({
            label: size,
            value: size,
        }));

        const newCategoryOptions = [...new Set(dataList.map(item => item.warehouse_category?.name).filter(Boolean))].map(category => ({
            label: category,
            value: category,
        }));

        setSizeOptions(newSizeOptions);
        setCategoryOptions(newCategoryOptions);

    }, [dataList]);

    useEffect(() => {
        const filteredList = dataList.filter(item =>
            (item.available > 0) &&
            (!categoryFilter || item.warehouse_category?.name === categoryFilter) &&
            (!sizeFilter || item.size === sizeFilter) &&
            (!phraseFilter || item.name?.toLowerCase().includes(phraseFilter.toLowerCase()))
        );

        // Recalculate available stock by restoring previously assigned quantities
        const adjustedItemsAvailableStock = restoreAvailableStockItems(
            filteredList, 
            dataPersonalProtectiveEquipment.assigned_items
        );

        setFilteredDataList(adjustedItemsAvailableStock);

    }, [categoryFilter, sizeFilter, phraseFilter]);



    useEffect(() => {
        setSelectedPerson(null);
        validation.setFieldValue('person_id', null);
        setSelectedCompany(selectedEstablishment ? selectedEstablishment.company_id : null);
    }, [selectedEstablishment]);




    useEffect(() => {
        if (selectedPerson) {
            dispatch(getPersonalProtectiveEquipmentByPersonId({ person_id: selectedPerson?._id }));
        }
    }, [selectedPerson]);



    useEffect(() => {
        if (personalProtectiveEquipmentList.length > 0 && selectedPerson) {
            const formattedData = personalProtectiveEquipmentList.flatMap((item) =>
                item.assigned_items.map((assignedItem) => ({
                    document: null,
                    personal_protective_equipment_status: item.personal_protective_equipment_status,
                    code: item.code,
                    delivery_date: item.delivery_date ?? null,
                    establishment_name: item.establishment?.name ?? "Desconocido",
                    quantity: assignedItem.quantity,
                    unit_measurement_name: assignedItem.unit_measurement_name,
                    name: assignedItem.name,
                    size: assignedItem.size,
                    price: assignedItem.price,
                    warehouse: item.warehouse?.name ?? "No asignada",
                    // price : item.
                }))
            );

            setDataListPerson(formattedData);
        } else {
            setDataListPerson([]);
        }
    }, [personalProtectiveEquipmentList, selectedPerson]);


    useEffect(() => {
        if (dataPersonalProtectiveEquipment && dataPersonalProtectiveEquipment._id) {
            dataPersonalProtectiveEquipment.assigned_items.forEach(item => {
                setSelectedItems((prev) => ({
                    ...prev,
                    [item.warehouse_item_id]: { quantity: item.quantity || 1 },
                }));
            });
        }

    }, [dataPersonalProtectiveEquipment]);

    const handlePhraseFilter = (e) => {
        const { value } = e.target;
        setPhraseFilter(value);
    };

    const handleCategoryFilter = (optionSelected) => {
        if (optionSelected) {
            setCategoryFilter(optionSelected.warehouse_category?.name);
        } else {
            setCategoryFilter(null); // Si no hay selección, establecer en null
        }
    };

    const handleSizeFilter = (optionSelected) => {
        if (optionSelected) {
            setSizeFilter(optionSelected.size);
        } else {
            setSizeFilter(null); // Si no hay selección, establecer en null
        }
    };


    // Cargar ítems al seleccionar bodega
    useEffect(() => {
        if (validation.values.warehouse_id) {
            dispatch(
                getWarehouseItemList({
                    warehouse_id: validation.values.warehouse_id,
                    all: false
                })
            );
        }
        else {
            setFilteredDataList([])
        }
    }, [
        validation.values.warehouse_id,
    ]);


    // Manejar selección de ítems
    const handleItemSelect = (itemId, available) => {
        if (available > 0) {
            setSelectedItems((prev) => {
                const newItems = { ...prev };
                if (newItems[itemId]) {
                    delete newItems[itemId];
                } else {
                    newItems[itemId] = { quantity: 1 };
                }
                return newItems;
            });
        }
    };

    // Manejar cambio de cantidad
    const handleQuantityChange = (itemId, value, available) => {
        const quantity = (Math.max(1, Math.min(available, Number(value) || 1)));
        
        setSelectedItems((prev) => ({
            ...prev,
            [itemId]: { quantity },
        }));
    };
    
    useEffect(() => {
        const costCenterAvailableList = [
            ...(
                selectedPerson?.cost_center ? 
                [
                    {
                        value: selectedPerson.cost_center._id,
                        label: (
                            selectedPerson.cost_center.name +
                            ': ' +
                            selectedPerson.cost_center.code
                        ),
                        item: {
                            ...selectedPerson.cost_center,
                            ...{is_person: true}
                        }
                    }
                ] : []
            ),
            ...(
                selectedEstablishment?.cost_center ? 
                [
                    {
                        value: selectedEstablishment.cost_center._id,
                        label: (
                            selectedEstablishment.cost_center.name +
                            ': ' +
                            selectedEstablishment.cost_center.code
                        ),
                        item: {
                            ...selectedEstablishment.cost_center,
                            ...{is_person: false}
                        }
                    }
                ] : []
            )
        ];
        setCostCenterList(costCenterAvailableList);
    }, [
        selectedPerson, 
        selectedEstablishment
    ])

    useEffect(() => {
        if(costCenterList){
            const costCenterPerson = costCenterList.find((item) => item.item.is_person == true);
            if(costCenterPerson) setCostCenterDefault(costCenterPerson);
        }else{

        }
    }, [costCenterList])

    useEffect(() => {
        if(!selectedPerson){
            setCostCenterDefault(null);
            validation.setFieldValue('cost_center_id', '');
        }
    }, [selectedPerson])

    const columns = useMemo(
        () => [
            { header: 'Ítem', accessorKey: 'name', size: 'auto' },
            { header: 'Cantidad', accessorKey: 'quantity', size: 'auto' },
            { header: 'Unidad', accessorKey: 'unit_measurement_name', size: 'auto' },
            { header: 'Talla', accessorKey: 'size', size: 'auto' }, {
                header: 'Estado', accessorKey: 'personal_protective_equipment_status_name', size: 'auto',
                Cell: ({ row }) => {
                    let status = row.original.personal_protective_equipment_status
                    let bgColor = status?.bgcolor;
                    let txColor = status?.txcolor;
                    return (
                        <div className='d-flex align-items-center'>
                            <span className={`badge`} style={{ backgroundColor: bgColor, color: txColor }}>
                                {status
                                    ? status.name.toUpperCase()
                                    : ''}
                            </span>
                        </div>
                    );
                },
            },
            { header: 'code', accessorKey: 'code', size: 'auto' },
            { header: 'Fecha Entrega', accessorKey: 'delivery_date', dataType: 'datetime', size: 'auto' },
            { header: 'Establecimiento', accessorKey: 'establishment_name', size: 'auto' },
        ],
    );

    return (
        <Form
            className='tablelist-form'
            onSubmit={e => {
                e.preventDefault();
                console.log('ve: ', validation.errors)
                if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
                validation.handleSubmit();
                return false;
            }}
        >
            <ModalBody className='modal-body'>
                <TabContent activeTab={activeTab}>
                    <TabPane tabId='1'>
                        <Row className='g-3'>
                            <Col lg={4}>
                                <OSelect
                                    key={'establishment_id'}
                                    label='Establecimiento de Destino'
                                    id='establishment_id'
                                    name='establishment_id'
                                    isRequired={true}
                                    value={dataPersonalProtectiveEquipment?.establishment_id || ''}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    onSelect={setSelectedEstablishment}
                                    requestApi={() => getEstablishmentList({ status_code: 'ACT' })}
                                    validation={validation}
                                />
                            </Col>
                            <Col lg={4}>
                                <OSelect
                                    key={(
                                        'warehouse_destination_id' +
                                        selectedEstablishment?._id || ''
                                    )}
                                    label="Bodega EPP de Destino"
                                    id="warehouse_destination_id"
                                    name="warehouse_destination_id"
                                    isRequired={true}
                                    value={validation.values.warehouse_destination_id || ''}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    onSelect={setSelectedWarehouse}
                                    requestApi={
                                        () => 
                                            getWarehouseList(
                                                {
                                                    establishment_id: validation.values.establishment_id,
                                                    warehouse_usage_type_code: 'EPP' 
                                                }
                                            )
                                    }
                                    validation={validation}
                                />
                            </Col>
                        </Row>
                        <Row className='g-3 pt-3'>
                            <Col lg={3} >
                                <OInput
                                    name='pick_document_number'
                                    label='Nro. Guía de Despacho'
                                    type='text'
                                    validation={validation}
                                    isRequired={true}
                                    classNameLabel='form-label'
                                    classNameInput='form-control'
                                />
                            </Col>
                            <Col lg={7}>
                                <Label for="document">Guía de Despacho <span style={{ color: 'red' }}>*</span></Label>
                                <Input
                                    name='document'
                                    id='document'
                                    className='form-control'
                                    placeholder='Ingrese el documento'
                                    type='file'
                                    accept='.pdf'
                                    validate={{ required: { value: true } }}
                                    onChange={(e) => {
                                        const file = e.currentTarget.files[0];
                                        validation.setFieldValue("document", file || '');
                                    }}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.document && validation.errors.document ? true : false}
                                />
                                {validation.touched.document &&
                                    validation.errors.document ? (
                                    <FormFeedback type='invalid'>
                                        {validation.errors.document}
                                    </FormFeedback>
                                ) : null}
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId='2'>
                        <Row>
                            <Col lg={3}>
                                <Row>
                                    <Col lg={12} className='p-2'>
                                        <OSelect
                                            key={(
                                                'warehouse_id' +
                                                selectedEstablishment?._id || ''
                                            )}
                                            label="Bodega"
                                            id="warehouse_id"
                                            name="warehouse_id"
                                            isRequired={true}
                                            value={validation.values.warehouse_id || ''}
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            onSelect={setSelectedWarehouse}
                                            requestApi={() => getWarehouseList({ warehouse_type_code: 'FSC' })}
                                            validation={validation}
                                        />
                                    </Col>

                                    <Col lg={12} className='p-2'>
                                        <Label for='name' className='form-label'>
                                            Filtrar por Frase
                                        </Label>
                                        <Input
                                            name='phrase'
                                            id='phrase'
                                            className='form-control'
                                            placeholder='Ingrese una frase'
                                            type='text'
                                            onChange={handlePhraseFilter}
                                        />
                                    </Col>

                                    <Col lg={12} className='p-2'>
                                        {Object.keys(selectedItems).length === 0 && (
                                            <div className="alert alert-primary alert-dismissible alert-label-icon rounded-label fade show" role="alert">
                                                <i className="icon-info label-icon"></i>Debe seleccionar al menos un ítem de la bodega para continuar.
                                            </div>
                                        )}
                                    </Col>
                                </Row>
                            </Col>
                            <Col lg={9}>
                                {/* Tabla fija con ítems seleccionados */}
                                {Object.keys(selectedItems).length > 0 && (
                                    <Row>
                                        <Col>
                                            <h5>Seleccionados</h5>
                                            <Table bordered size="sm" striped>
                                                <thead>
                                                    <tr>
                                                        <th className='text-center w-auto'>#</th>
                                                        <th className='text-center w-auto'>NOMBRE</th>
                                                        {/* <th className='text-center w-auto'>TALLA</th> */}
                                                        <th className='text-center w-auto'>DISPONIBLE</th>
                                                        <th className='text-center w-auto'>UNIDAD</th>
                                                        <th className='text-center w-auto'>CANTIDAD</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Object.entries(selectedItems).map(([id, data]) => {
                                                        const item = filteredDataList.find((i) => i._id === id);
                                                        if (!item || !data) return null;

                                                        const { quantity } = data;

                                                        return (
                                                            <tr key={item._id}>
                                                                <td className='text-center pt-2 pb-2'>
                                                                    <Input
                                                                        type="checkbox"
                                                                        className='form-check-input fs-15'
                                                                        checked
                                                                        onChange={() => handleItemSelect(item._id, item.available)}
                                                                    />
                                                                </td>
                                                                <td className='pt-3 pb-3'>{item.name}</td>
                                                                {/* <td className='text-center pt-3 pb-3'>{item.size}</td> */}
                                                                <td className='text-center pt-3 pb-3'>{item.available}</td>
                                                                <td className='text-center pt-3 pb-3'>{item.unit_measurement?.name.toUpperCase()}</td>
                                                                <td className='text-center'>
                                                                    <div className="input-step">
                                                                        <button
                                                                            type="button"
                                                                            className="minus"
                                                                            onClick={() => handleQuantityChange(item._id, quantity - 1, item.available)}
                                                                        >
                                                                            –
                                                                        </button>

                                                                        <Input
                                                                            type="number"
                                                                            className="product-quantity pt-1 pb-1"
                                                                            value={quantity}
                                                                            min="1"
                                                                            max={item.available}
                                                                            readOnly
                                                                        />

                                                                        <button
                                                                            type="button"
                                                                            className="plus"
                                                                            onClick={() => handleQuantityChange(item._id, quantity + 1, item.available)}
                                                                        >
                                                                            +
                                                                        </button>
                                                                    </div>
                                                                </td>

                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                )}

                                {/* Tabla completa con scroll */}
                                {filteredDataList.length > 0 ? (
                                    <Row className="mt-3">
                                        <Col>
                                            <SimpleBar style={{ maxHeight: "300px" }}>
                                                <Table bordered hover striped>
                                                    <thead>
                                                        <tr>
                                                            <th className='text-center'>#</th>
                                                            <th className='text-center'>NOMBRE</th>
                                                            {/* <th className='text-center'>TALLA</th> */}
                                                            <th className='text-center'>DISPONIBLE</th>
                                                            <th className='text-center'>UNIDAD</th>
                                                            {/* <th>CANTIDAD</th> */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {filteredDataList
                                                            .filter((item) => !selectedItems[item._id])
                                                            .map((item) => (
                                                                <tr key={item._id}>
                                                                    <td>
                                                                        <Input
                                                                            type="checkbox"
                                                                            className='form-check-input fs-15'
                                                                            checked={!!selectedItems[item._id]}
                                                                            disabled={item.available === 0}
                                                                            onChange={() => handleItemSelect(item._id, item.available)}
                                                                        />
                                                                    </td>
                                                                    <td>{item.name}</td>
                                                                    {/* <td className='text-center'>{item.size}</td> */}
                                                                    <td className='text-center'>{item.available}</td>
                                                                    <td className='text-center'>{item.unit_measurement?.name.toUpperCase()}</td>
                                                                    {/* <td>
                                                                        {selectedItems[item._id] ? (
                                                                            <Input
                                                                                type="number"
                                                                                min="1"
                                                                                max={item.available}
                                                                                value={selectedItems[item._id]?.quantity || ""}
                                                                                onChange={(e) =>
                                                                                    handleQuantityChange(
                                                                                        item._id,
                                                                                        e.target.value,
                                                                                        item.available
                                                                                    )
                                                                                }
                                                                            />
                                                                        ) : (
                                                                            "-"
                                                                        )}
                                                                    </td> */}
                                                                </tr>
                                                            ))}
                                                    </tbody>
                                                </Table>
                                            </SimpleBar>
                                        </Col>
                                    </Row>
                                ) : (
                                    <Row className="mt-3">
                                        <Col>
                                            <div className="text-center text-muted">
                                                Esta bodega no cuenta con ítems
                                            </div>
                                        </Col>
                                    </Row>
                                )}
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId='3'>
                        <Row>
                            <Col lg={12}>
                                <SimpleBar style={{ maxHeight: "300px" }}>
                                    <ODataGrid
                                        enableTopToolbar={false}
                                        columns={columns}
                                        data={dataListPerson || []}
                                        nameFile={'asignación_de_epp'}
                                    />
                                </SimpleBar>
                            </Col>
                        </Row>
                    </TabPane>
                </TabContent>
            </ModalBody >
            <div className='modal-footer'>
                <div className='hstack gap-2 justify-content-end'>
                    <Button
                        type='button'
                        onClick={() => {
                            handleToggleModal();
                        }}
                        className='btn-danger btn-label'
                    >
                        <i className='icon-x label-icon'></i>
                        Cancelar
                    </Button>
                    <button
                        type='submit'
                        className='btn btn-label btn-primary'
                        id='add-btn'
                        disabled={loading}
                    >
                        {loading ? (<i className='label-icon'><Spinner size='sm' /></i>) : (<i className='ri-save-3-line label-icon'></i>)}
                        {isEdit ? 'Actualizar Transferencia de' : 'Transferir'} Equipamiento de Protección Personal
                    </button>
                </div>
            </div>
        </Form >
    );
};

export default PersonalProtectiveEquipmentTransferForm;
